/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DispatchTimelineRouteImport } from './routes/dispatch-timeline'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppWorkersRouteImport } from './routes/_app/workers'
import { Route as AppRentalAssetsRouteImport } from './routes/_app/rental-assets'
import { Route as AppOrdersRouteImport } from './routes/_app/orders'
import { Route as AppActiveRentalsRouteImport } from './routes/_app/active-rentals'
import { Route as AppWorkersIndexRouteImport } from './routes/_app/workers/index'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppRentalAssetsIndexRouteImport } from './routes/_app/rental-assets/index'
import { Route as AppQuotesIndexRouteImport } from './routes/_app/quotes/index'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppJobsIndexRouteImport } from './routes/_app/jobs/index'
import { Route as AppInvoicesIndexRouteImport } from './routes/_app/invoices/index'
import { Route as AppDispatchIndexRouteImport } from './routes/_app/dispatch/index'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as DriverJobsJobIdRouteImport } from './routes/driver/jobs/$jobId'
import { Route as AppWorkersWorkerIdRouteImport } from './routes/_app/workers/$workerId'
import { Route as AppReportsRentalRouteImport } from './routes/_app/reports/rental'
import { Route as AppRentalAssetsExceptionsRouteImport } from './routes/_app/rental-assets/exceptions'
import { Route as AppRentalAssetsAssetIdRouteImport } from './routes/_app/rental-assets/$assetId'
import { Route as AppQuotesSchedulingRouteImport } from './routes/_app/quotes/scheduling'
import { Route as AppQuotesNewRouteImport } from './routes/_app/quotes/new'
import { Route as AppQuotesQuoteIdRouteImport } from './routes/_app/quotes/$quoteId'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app/projects/$projectId'
import { Route as AppJobsJobIdRouteImport } from './routes/_app/jobs/$jobId'
import { Route as AppInvoicesInvoiceIdRouteImport } from './routes/_app/invoices/$invoiceId'
import { Route as AppDispatchReportRouteImport } from './routes/_app/dispatch/report'
import { Route as AppCustomersCustomerIdRouteImport } from './routes/_app/customers/$customerId'
import { Route as AppWorkersTypesIndexRouteImport } from './routes/_app/workers/types/index'
import { Route as AppRentalAssetsTypesIndexRouteImport } from './routes/_app/rental-assets/types/index'
import { Route as AppRentalAssetsOfferingsIndexRouteImport } from './routes/_app/rental-assets/offerings/index'
import { Route as AppRentalAssetsCompaniesIndexRouteImport } from './routes/_app/rental-assets/companies/index'
import { Route as AppQuotesQuoteIdIndexRouteImport } from './routes/_app/quotes/$quoteId/index'
import { Route as AppProjectsCreateIndexRouteImport } from './routes/_app/projects/create/index'
import { Route as AppProjectsProjectIdIndexRouteImport } from './routes/_app/projects/$projectId/index'
import { Route as AppJobsCreateIndexRouteImport } from './routes/_app/jobs/create/index'
import { Route as AppWorkersTypesTypeIdRouteImport } from './routes/_app/workers/types/$typeId'
import { Route as AppRentalAssetsTypesTypeIdRouteImport } from './routes/_app/rental-assets/types/$typeId'
import { Route as AppRentalAssetsStockTypeIdRouteImport } from './routes/_app/rental-assets/stock/$typeId'
import { Route as AppQuotesQuoteIdSchedulingRouteImport } from './routes/_app/quotes/$quoteId/scheduling'
import { Route as AppQuotesQuoteIdRequirementsRouteImport } from './routes/_app/quotes/$quoteId/requirements'
import { Route as AppProjectsCreateSplatRouteImport } from './routes/_app/projects/create/$'
import { Route as AppProjectsProjectIdServiceVisitsRouteImport } from './routes/_app/projects/$projectId/service-visits'
import { Route as AppProjectsProjectIdMoreSitesRouteImport } from './routes/_app/projects/$projectId/more-sites'
import { Route as AppJobsCreateStepRouteImport } from './routes/_app/jobs/create/$step'
import { Route as AppQuotesQuoteIdCreateProjectIndexRouteImport } from './routes/_app/quotes/$quoteId/create-project/index'
import { Route as AppQuotesQuoteIdCreateProjectSplatRouteImport } from './routes/_app/quotes/$quoteId/create-project/$'
import { Route as AppProjectsProjectIdSchedulesScheduleIdRouteImport } from './routes/_app/projects/$projectId/schedules/$scheduleId'
import { Route as AppProjectsProjectIdJobsCreateRouteImport } from './routes/_app/projects/$projectId/jobs/create'
import { Route as AppProjectsProjectIdJobsAddRouteImport } from './routes/_app/projects/$projectId/jobs/add'
import { Route as AppJobsCreateDoneJobIdRouteImport } from './routes/_app/jobs/create/done/$jobId'
import { Route as AppProjectsProjectIdJobsCreateSplatRouteImport } from './routes/_app/projects/$projectId/jobs/create/$'

const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DispatchTimelineRoute = DispatchTimelineRouteImport.update({
  id: '/dispatch-timeline',
  path: '/dispatch-timeline',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkersRoute = AppWorkersRouteImport.update({
  id: '/workers',
  path: '/workers',
  getParentRoute: () => AppRoute,
} as any)
const AppRentalAssetsRoute = AppRentalAssetsRouteImport.update({
  id: '/rental-assets',
  path: '/rental-assets',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppActiveRentalsRoute = AppActiveRentalsRouteImport.update({
  id: '/active-rentals',
  path: '/active-rentals',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkersIndexRoute = AppWorkersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWorkersRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppRentalAssetsIndexRoute = AppRentalAssetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRentalAssetsRoute,
} as any)
const AppQuotesIndexRoute = AppQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsIndexRoute = AppJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AppRoute,
} as any)
const AppDispatchIndexRoute = AppDispatchIndexRouteImport.update({
  id: '/dispatch/',
  path: '/dispatch/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const DriverJobsJobIdRoute = DriverJobsJobIdRouteImport.update({
  id: '/driver/jobs/$jobId',
  path: '/driver/jobs/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWorkersWorkerIdRoute = AppWorkersWorkerIdRouteImport.update({
  id: '/$workerId',
  path: '/$workerId',
  getParentRoute: () => AppWorkersRoute,
} as any)
const AppReportsRentalRoute = AppReportsRentalRouteImport.update({
  id: '/reports/rental',
  path: '/reports/rental',
  getParentRoute: () => AppRoute,
} as any)
const AppRentalAssetsExceptionsRoute =
  AppRentalAssetsExceptionsRouteImport.update({
    id: '/exceptions',
    path: '/exceptions',
    getParentRoute: () => AppRentalAssetsRoute,
  } as any)
const AppRentalAssetsAssetIdRoute = AppRentalAssetsAssetIdRouteImport.update({
  id: '/$assetId',
  path: '/$assetId',
  getParentRoute: () => AppRentalAssetsRoute,
} as any)
const AppQuotesSchedulingRoute = AppQuotesSchedulingRouteImport.update({
  id: '/quotes/scheduling',
  path: '/quotes/scheduling',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesNewRoute = AppQuotesNewRouteImport.update({
  id: '/quotes/new',
  path: '/quotes/new',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesQuoteIdRoute = AppQuotesQuoteIdRouteImport.update({
  id: '/quotes/$quoteId',
  path: '/quotes/$quoteId',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsJobIdRoute = AppJobsJobIdRouteImport.update({
  id: '/jobs/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesInvoiceIdRoute = AppInvoicesInvoiceIdRouteImport.update({
  id: '/invoices/$invoiceId',
  path: '/invoices/$invoiceId',
  getParentRoute: () => AppRoute,
} as any)
const AppDispatchReportRoute = AppDispatchReportRouteImport.update({
  id: '/dispatch/report',
  path: '/dispatch/report',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersCustomerIdRoute = AppCustomersCustomerIdRouteImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkersTypesIndexRoute = AppWorkersTypesIndexRouteImport.update({
  id: '/types/',
  path: '/types/',
  getParentRoute: () => AppWorkersRoute,
} as any)
const AppRentalAssetsTypesIndexRoute =
  AppRentalAssetsTypesIndexRouteImport.update({
    id: '/types/',
    path: '/types/',
    getParentRoute: () => AppRentalAssetsRoute,
  } as any)
const AppRentalAssetsOfferingsIndexRoute =
  AppRentalAssetsOfferingsIndexRouteImport.update({
    id: '/offerings/',
    path: '/offerings/',
    getParentRoute: () => AppRentalAssetsRoute,
  } as any)
const AppRentalAssetsCompaniesIndexRoute =
  AppRentalAssetsCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AppRentalAssetsRoute,
  } as any)
const AppQuotesQuoteIdIndexRoute = AppQuotesQuoteIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppQuotesQuoteIdRoute,
} as any)
const AppProjectsCreateIndexRoute = AppProjectsCreateIndexRouteImport.update({
  id: '/projects/create/',
  path: '/projects/create/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdIndexRoute =
  AppProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppJobsCreateIndexRoute = AppJobsCreateIndexRouteImport.update({
  id: '/jobs/create/',
  path: '/jobs/create/',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkersTypesTypeIdRoute = AppWorkersTypesTypeIdRouteImport.update({
  id: '/types/$typeId',
  path: '/types/$typeId',
  getParentRoute: () => AppWorkersRoute,
} as any)
const AppRentalAssetsTypesTypeIdRoute =
  AppRentalAssetsTypesTypeIdRouteImport.update({
    id: '/types/$typeId',
    path: '/types/$typeId',
    getParentRoute: () => AppRentalAssetsRoute,
  } as any)
const AppRentalAssetsStockTypeIdRoute =
  AppRentalAssetsStockTypeIdRouteImport.update({
    id: '/stock/$typeId',
    path: '/stock/$typeId',
    getParentRoute: () => AppRentalAssetsRoute,
  } as any)
const AppQuotesQuoteIdSchedulingRoute =
  AppQuotesQuoteIdSchedulingRouteImport.update({
    id: '/scheduling',
    path: '/scheduling',
    getParentRoute: () => AppQuotesQuoteIdRoute,
  } as any)
const AppQuotesQuoteIdRequirementsRoute =
  AppQuotesQuoteIdRequirementsRouteImport.update({
    id: '/requirements',
    path: '/requirements',
    getParentRoute: () => AppQuotesQuoteIdRoute,
  } as any)
const AppProjectsCreateSplatRoute = AppProjectsCreateSplatRouteImport.update({
  id: '/projects/create/$',
  path: '/projects/create/$',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdServiceVisitsRoute =
  AppProjectsProjectIdServiceVisitsRouteImport.update({
    id: '/service-visits',
    path: '/service-visits',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdMoreSitesRoute =
  AppProjectsProjectIdMoreSitesRouteImport.update({
    id: '/more-sites',
    path: '/more-sites',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppJobsCreateStepRoute = AppJobsCreateStepRouteImport.update({
  id: '/jobs/create/$step',
  path: '/jobs/create/$step',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesQuoteIdCreateProjectIndexRoute =
  AppQuotesQuoteIdCreateProjectIndexRouteImport.update({
    id: '/create-project/',
    path: '/create-project/',
    getParentRoute: () => AppQuotesQuoteIdRoute,
  } as any)
const AppQuotesQuoteIdCreateProjectSplatRoute =
  AppQuotesQuoteIdCreateProjectSplatRouteImport.update({
    id: '/create-project/$',
    path: '/create-project/$',
    getParentRoute: () => AppQuotesQuoteIdRoute,
  } as any)
const AppProjectsProjectIdSchedulesScheduleIdRoute =
  AppProjectsProjectIdSchedulesScheduleIdRouteImport.update({
    id: '/schedules/$scheduleId',
    path: '/schedules/$scheduleId',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdJobsCreateRoute =
  AppProjectsProjectIdJobsCreateRouteImport.update({
    id: '/jobs/create',
    path: '/jobs/create',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdJobsAddRoute =
  AppProjectsProjectIdJobsAddRouteImport.update({
    id: '/jobs/add',
    path: '/jobs/add',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppJobsCreateDoneJobIdRoute = AppJobsCreateDoneJobIdRouteImport.update({
  id: '/jobs/create/done/$jobId',
  path: '/jobs/create/done/$jobId',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdJobsCreateSplatRoute =
  AppProjectsProjectIdJobsCreateSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AppProjectsProjectIdJobsCreateRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/dispatch-timeline': typeof DispatchTimelineRoute
  '/login': typeof LoginRoute
  '/verify': typeof VerifyRoute
  '/active-rentals': typeof AppActiveRentalsRoute
  '/orders': typeof AppOrdersRoute
  '/rental-assets': typeof AppRentalAssetsRouteWithChildren
  '/workers': typeof AppWorkersRouteWithChildren
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/dispatch/report': typeof AppDispatchReportRoute
  '/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRoute
  '/jobs/$jobId': typeof AppJobsJobIdRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/quotes/$quoteId': typeof AppQuotesQuoteIdRouteWithChildren
  '/quotes/new': typeof AppQuotesNewRoute
  '/quotes/scheduling': typeof AppQuotesSchedulingRoute
  '/rental-assets/$assetId': typeof AppRentalAssetsAssetIdRoute
  '/rental-assets/exceptions': typeof AppRentalAssetsExceptionsRoute
  '/reports/rental': typeof AppReportsRentalRoute
  '/workers/$workerId': typeof AppWorkersWorkerIdRoute
  '/driver/jobs/$jobId': typeof DriverJobsJobIdRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/dispatch/': typeof AppDispatchIndexRoute
  '/invoices/': typeof AppInvoicesIndexRoute
  '/jobs/': typeof AppJobsIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/quotes/': typeof AppQuotesIndexRoute
  '/rental-assets/': typeof AppRentalAssetsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/workers/': typeof AppWorkersIndexRoute
  '/jobs/create/$step': typeof AppJobsCreateStepRoute
  '/projects/$projectId/more-sites': typeof AppProjectsProjectIdMoreSitesRoute
  '/projects/$projectId/service-visits': typeof AppProjectsProjectIdServiceVisitsRoute
  '/projects/create/$': typeof AppProjectsCreateSplatRoute
  '/quotes/$quoteId/requirements': typeof AppQuotesQuoteIdRequirementsRoute
  '/quotes/$quoteId/scheduling': typeof AppQuotesQuoteIdSchedulingRoute
  '/rental-assets/stock/$typeId': typeof AppRentalAssetsStockTypeIdRoute
  '/rental-assets/types/$typeId': typeof AppRentalAssetsTypesTypeIdRoute
  '/workers/types/$typeId': typeof AppWorkersTypesTypeIdRoute
  '/jobs/create/': typeof AppJobsCreateIndexRoute
  '/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
  '/projects/create/': typeof AppProjectsCreateIndexRoute
  '/quotes/$quoteId/': typeof AppQuotesQuoteIdIndexRoute
  '/rental-assets/companies/': typeof AppRentalAssetsCompaniesIndexRoute
  '/rental-assets/offerings/': typeof AppRentalAssetsOfferingsIndexRoute
  '/rental-assets/types/': typeof AppRentalAssetsTypesIndexRoute
  '/workers/types/': typeof AppWorkersTypesIndexRoute
  '/jobs/create/done/$jobId': typeof AppJobsCreateDoneJobIdRoute
  '/projects/$projectId/jobs/add': typeof AppProjectsProjectIdJobsAddRoute
  '/projects/$projectId/jobs/create': typeof AppProjectsProjectIdJobsCreateRouteWithChildren
  '/projects/$projectId/schedules/$scheduleId': typeof AppProjectsProjectIdSchedulesScheduleIdRoute
  '/quotes/$quoteId/create-project/$': typeof AppQuotesQuoteIdCreateProjectSplatRoute
  '/quotes/$quoteId/create-project/': typeof AppQuotesQuoteIdCreateProjectIndexRoute
  '/projects/$projectId/jobs/create/$': typeof AppProjectsProjectIdJobsCreateSplatRoute
}
export interface FileRoutesByTo {
  '/dispatch-timeline': typeof DispatchTimelineRoute
  '/login': typeof LoginRoute
  '/verify': typeof VerifyRoute
  '/active-rentals': typeof AppActiveRentalsRoute
  '/orders': typeof AppOrdersRoute
  '/': typeof AppIndexRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/dispatch/report': typeof AppDispatchReportRoute
  '/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRoute
  '/jobs/$jobId': typeof AppJobsJobIdRoute
  '/quotes/new': typeof AppQuotesNewRoute
  '/quotes/scheduling': typeof AppQuotesSchedulingRoute
  '/rental-assets/$assetId': typeof AppRentalAssetsAssetIdRoute
  '/rental-assets/exceptions': typeof AppRentalAssetsExceptionsRoute
  '/reports/rental': typeof AppReportsRentalRoute
  '/workers/$workerId': typeof AppWorkersWorkerIdRoute
  '/driver/jobs/$jobId': typeof DriverJobsJobIdRoute
  '/customers': typeof AppCustomersIndexRoute
  '/dispatch': typeof AppDispatchIndexRoute
  '/invoices': typeof AppInvoicesIndexRoute
  '/jobs': typeof AppJobsIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/quotes': typeof AppQuotesIndexRoute
  '/rental-assets': typeof AppRentalAssetsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/workers': typeof AppWorkersIndexRoute
  '/jobs/create/$step': typeof AppJobsCreateStepRoute
  '/projects/$projectId/more-sites': typeof AppProjectsProjectIdMoreSitesRoute
  '/projects/$projectId/service-visits': typeof AppProjectsProjectIdServiceVisitsRoute
  '/projects/create/$': typeof AppProjectsCreateSplatRoute
  '/quotes/$quoteId/requirements': typeof AppQuotesQuoteIdRequirementsRoute
  '/quotes/$quoteId/scheduling': typeof AppQuotesQuoteIdSchedulingRoute
  '/rental-assets/stock/$typeId': typeof AppRentalAssetsStockTypeIdRoute
  '/rental-assets/types/$typeId': typeof AppRentalAssetsTypesTypeIdRoute
  '/workers/types/$typeId': typeof AppWorkersTypesTypeIdRoute
  '/jobs/create': typeof AppJobsCreateIndexRoute
  '/projects/$projectId': typeof AppProjectsProjectIdIndexRoute
  '/projects/create': typeof AppProjectsCreateIndexRoute
  '/quotes/$quoteId': typeof AppQuotesQuoteIdIndexRoute
  '/rental-assets/companies': typeof AppRentalAssetsCompaniesIndexRoute
  '/rental-assets/offerings': typeof AppRentalAssetsOfferingsIndexRoute
  '/rental-assets/types': typeof AppRentalAssetsTypesIndexRoute
  '/workers/types': typeof AppWorkersTypesIndexRoute
  '/jobs/create/done/$jobId': typeof AppJobsCreateDoneJobIdRoute
  '/projects/$projectId/jobs/add': typeof AppProjectsProjectIdJobsAddRoute
  '/projects/$projectId/jobs/create': typeof AppProjectsProjectIdJobsCreateRouteWithChildren
  '/projects/$projectId/schedules/$scheduleId': typeof AppProjectsProjectIdSchedulesScheduleIdRoute
  '/quotes/$quoteId/create-project/$': typeof AppQuotesQuoteIdCreateProjectSplatRoute
  '/quotes/$quoteId/create-project': typeof AppQuotesQuoteIdCreateProjectIndexRoute
  '/projects/$projectId/jobs/create/$': typeof AppProjectsProjectIdJobsCreateSplatRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/dispatch-timeline': typeof DispatchTimelineRoute
  '/login': typeof LoginRoute
  '/verify': typeof VerifyRoute
  '/_app/active-rentals': typeof AppActiveRentalsRoute
  '/_app/orders': typeof AppOrdersRoute
  '/_app/rental-assets': typeof AppRentalAssetsRouteWithChildren
  '/_app/workers': typeof AppWorkersRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/_app/dispatch/report': typeof AppDispatchReportRoute
  '/_app/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRoute
  '/_app/jobs/$jobId': typeof AppJobsJobIdRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/_app/quotes/$quoteId': typeof AppQuotesQuoteIdRouteWithChildren
  '/_app/quotes/new': typeof AppQuotesNewRoute
  '/_app/quotes/scheduling': typeof AppQuotesSchedulingRoute
  '/_app/rental-assets/$assetId': typeof AppRentalAssetsAssetIdRoute
  '/_app/rental-assets/exceptions': typeof AppRentalAssetsExceptionsRoute
  '/_app/reports/rental': typeof AppReportsRentalRoute
  '/_app/workers/$workerId': typeof AppWorkersWorkerIdRoute
  '/driver/jobs/$jobId': typeof DriverJobsJobIdRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/dispatch/': typeof AppDispatchIndexRoute
  '/_app/invoices/': typeof AppInvoicesIndexRoute
  '/_app/jobs/': typeof AppJobsIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/quotes/': typeof AppQuotesIndexRoute
  '/_app/rental-assets/': typeof AppRentalAssetsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/workers/': typeof AppWorkersIndexRoute
  '/_app/jobs/create/$step': typeof AppJobsCreateStepRoute
  '/_app/projects/$projectId/more-sites': typeof AppProjectsProjectIdMoreSitesRoute
  '/_app/projects/$projectId/service-visits': typeof AppProjectsProjectIdServiceVisitsRoute
  '/_app/projects/create/$': typeof AppProjectsCreateSplatRoute
  '/_app/quotes/$quoteId/requirements': typeof AppQuotesQuoteIdRequirementsRoute
  '/_app/quotes/$quoteId/scheduling': typeof AppQuotesQuoteIdSchedulingRoute
  '/_app/rental-assets/stock/$typeId': typeof AppRentalAssetsStockTypeIdRoute
  '/_app/rental-assets/types/$typeId': typeof AppRentalAssetsTypesTypeIdRoute
  '/_app/workers/types/$typeId': typeof AppWorkersTypesTypeIdRoute
  '/_app/jobs/create/': typeof AppJobsCreateIndexRoute
  '/_app/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
  '/_app/projects/create/': typeof AppProjectsCreateIndexRoute
  '/_app/quotes/$quoteId/': typeof AppQuotesQuoteIdIndexRoute
  '/_app/rental-assets/companies/': typeof AppRentalAssetsCompaniesIndexRoute
  '/_app/rental-assets/offerings/': typeof AppRentalAssetsOfferingsIndexRoute
  '/_app/rental-assets/types/': typeof AppRentalAssetsTypesIndexRoute
  '/_app/workers/types/': typeof AppWorkersTypesIndexRoute
  '/_app/jobs/create/done/$jobId': typeof AppJobsCreateDoneJobIdRoute
  '/_app/projects/$projectId/jobs/add': typeof AppProjectsProjectIdJobsAddRoute
  '/_app/projects/$projectId/jobs/create': typeof AppProjectsProjectIdJobsCreateRouteWithChildren
  '/_app/projects/$projectId/schedules/$scheduleId': typeof AppProjectsProjectIdSchedulesScheduleIdRoute
  '/_app/quotes/$quoteId/create-project/$': typeof AppQuotesQuoteIdCreateProjectSplatRoute
  '/_app/quotes/$quoteId/create-project/': typeof AppQuotesQuoteIdCreateProjectIndexRoute
  '/_app/projects/$projectId/jobs/create/$': typeof AppProjectsProjectIdJobsCreateSplatRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dispatch-timeline'
    | '/login'
    | '/verify'
    | '/active-rentals'
    | '/orders'
    | '/rental-assets'
    | '/workers'
    | '/customers/$customerId'
    | '/dispatch/report'
    | '/invoices/$invoiceId'
    | '/jobs/$jobId'
    | '/projects/$projectId'
    | '/quotes/$quoteId'
    | '/quotes/new'
    | '/quotes/scheduling'
    | '/rental-assets/$assetId'
    | '/rental-assets/exceptions'
    | '/reports/rental'
    | '/workers/$workerId'
    | '/driver/jobs/$jobId'
    | '/customers/'
    | '/dispatch/'
    | '/invoices/'
    | '/jobs/'
    | '/projects/'
    | '/quotes/'
    | '/rental-assets/'
    | '/settings/'
    | '/users/'
    | '/workers/'
    | '/jobs/create/$step'
    | '/projects/$projectId/more-sites'
    | '/projects/$projectId/service-visits'
    | '/projects/create/$'
    | '/quotes/$quoteId/requirements'
    | '/quotes/$quoteId/scheduling'
    | '/rental-assets/stock/$typeId'
    | '/rental-assets/types/$typeId'
    | '/workers/types/$typeId'
    | '/jobs/create/'
    | '/projects/$projectId/'
    | '/projects/create/'
    | '/quotes/$quoteId/'
    | '/rental-assets/companies/'
    | '/rental-assets/offerings/'
    | '/rental-assets/types/'
    | '/workers/types/'
    | '/jobs/create/done/$jobId'
    | '/projects/$projectId/jobs/add'
    | '/projects/$projectId/jobs/create'
    | '/projects/$projectId/schedules/$scheduleId'
    | '/quotes/$quoteId/create-project/$'
    | '/quotes/$quoteId/create-project/'
    | '/projects/$projectId/jobs/create/$'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/dispatch-timeline'
    | '/login'
    | '/verify'
    | '/active-rentals'
    | '/orders'
    | '/'
    | '/customers/$customerId'
    | '/dispatch/report'
    | '/invoices/$invoiceId'
    | '/jobs/$jobId'
    | '/quotes/new'
    | '/quotes/scheduling'
    | '/rental-assets/$assetId'
    | '/rental-assets/exceptions'
    | '/reports/rental'
    | '/workers/$workerId'
    | '/driver/jobs/$jobId'
    | '/customers'
    | '/dispatch'
    | '/invoices'
    | '/jobs'
    | '/projects'
    | '/quotes'
    | '/rental-assets'
    | '/settings'
    | '/users'
    | '/workers'
    | '/jobs/create/$step'
    | '/projects/$projectId/more-sites'
    | '/projects/$projectId/service-visits'
    | '/projects/create/$'
    | '/quotes/$quoteId/requirements'
    | '/quotes/$quoteId/scheduling'
    | '/rental-assets/stock/$typeId'
    | '/rental-assets/types/$typeId'
    | '/workers/types/$typeId'
    | '/jobs/create'
    | '/projects/$projectId'
    | '/projects/create'
    | '/quotes/$quoteId'
    | '/rental-assets/companies'
    | '/rental-assets/offerings'
    | '/rental-assets/types'
    | '/workers/types'
    | '/jobs/create/done/$jobId'
    | '/projects/$projectId/jobs/add'
    | '/projects/$projectId/jobs/create'
    | '/projects/$projectId/schedules/$scheduleId'
    | '/quotes/$quoteId/create-project/$'
    | '/quotes/$quoteId/create-project'
    | '/projects/$projectId/jobs/create/$'
  id:
    | '__root__'
    | '/_app'
    | '/dispatch-timeline'
    | '/login'
    | '/verify'
    | '/_app/active-rentals'
    | '/_app/orders'
    | '/_app/rental-assets'
    | '/_app/workers'
    | '/_app/'
    | '/_app/customers/$customerId'
    | '/_app/dispatch/report'
    | '/_app/invoices/$invoiceId'
    | '/_app/jobs/$jobId'
    | '/_app/projects/$projectId'
    | '/_app/quotes/$quoteId'
    | '/_app/quotes/new'
    | '/_app/quotes/scheduling'
    | '/_app/rental-assets/$assetId'
    | '/_app/rental-assets/exceptions'
    | '/_app/reports/rental'
    | '/_app/workers/$workerId'
    | '/driver/jobs/$jobId'
    | '/_app/customers/'
    | '/_app/dispatch/'
    | '/_app/invoices/'
    | '/_app/jobs/'
    | '/_app/projects/'
    | '/_app/quotes/'
    | '/_app/rental-assets/'
    | '/_app/settings/'
    | '/_app/users/'
    | '/_app/workers/'
    | '/_app/jobs/create/$step'
    | '/_app/projects/$projectId/more-sites'
    | '/_app/projects/$projectId/service-visits'
    | '/_app/projects/create/$'
    | '/_app/quotes/$quoteId/requirements'
    | '/_app/quotes/$quoteId/scheduling'
    | '/_app/rental-assets/stock/$typeId'
    | '/_app/rental-assets/types/$typeId'
    | '/_app/workers/types/$typeId'
    | '/_app/jobs/create/'
    | '/_app/projects/$projectId/'
    | '/_app/projects/create/'
    | '/_app/quotes/$quoteId/'
    | '/_app/rental-assets/companies/'
    | '/_app/rental-assets/offerings/'
    | '/_app/rental-assets/types/'
    | '/_app/workers/types/'
    | '/_app/jobs/create/done/$jobId'
    | '/_app/projects/$projectId/jobs/add'
    | '/_app/projects/$projectId/jobs/create'
    | '/_app/projects/$projectId/schedules/$scheduleId'
    | '/_app/quotes/$quoteId/create-project/$'
    | '/_app/quotes/$quoteId/create-project/'
    | '/_app/projects/$projectId/jobs/create/$'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  DispatchTimelineRoute: typeof DispatchTimelineRoute
  LoginRoute: typeof LoginRoute
  VerifyRoute: typeof VerifyRoute
  DriverJobsJobIdRoute: typeof DriverJobsJobIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dispatch-timeline': {
      id: '/dispatch-timeline'
      path: '/dispatch-timeline'
      fullPath: '/dispatch-timeline'
      preLoaderRoute: typeof DispatchTimelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workers': {
      id: '/_app/workers'
      path: '/workers'
      fullPath: '/workers'
      preLoaderRoute: typeof AppWorkersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rental-assets': {
      id: '/_app/rental-assets'
      path: '/rental-assets'
      fullPath: '/rental-assets'
      preLoaderRoute: typeof AppRentalAssetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/active-rentals': {
      id: '/_app/active-rentals'
      path: '/active-rentals'
      fullPath: '/active-rentals'
      preLoaderRoute: typeof AppActiveRentalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workers/': {
      id: '/_app/workers/'
      path: '/'
      fullPath: '/workers/'
      preLoaderRoute: typeof AppWorkersIndexRouteImport
      parentRoute: typeof AppWorkersRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rental-assets/': {
      id: '/_app/rental-assets/'
      path: '/'
      fullPath: '/rental-assets/'
      preLoaderRoute: typeof AppRentalAssetsIndexRouteImport
      parentRoute: typeof AppRentalAssetsRoute
    }
    '/_app/quotes/': {
      id: '/_app/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof AppQuotesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs/': {
      id: '/_app/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AppJobsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/': {
      id: '/_app/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AppInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dispatch/': {
      id: '/_app/dispatch/'
      path: '/dispatch'
      fullPath: '/dispatch/'
      preLoaderRoute: typeof AppDispatchIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/driver/jobs/$jobId': {
      id: '/driver/jobs/$jobId'
      path: '/driver/jobs/$jobId'
      fullPath: '/driver/jobs/$jobId'
      preLoaderRoute: typeof DriverJobsJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/workers/$workerId': {
      id: '/_app/workers/$workerId'
      path: '/$workerId'
      fullPath: '/workers/$workerId'
      preLoaderRoute: typeof AppWorkersWorkerIdRouteImport
      parentRoute: typeof AppWorkersRoute
    }
    '/_app/reports/rental': {
      id: '/_app/reports/rental'
      path: '/reports/rental'
      fullPath: '/reports/rental'
      preLoaderRoute: typeof AppReportsRentalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rental-assets/exceptions': {
      id: '/_app/rental-assets/exceptions'
      path: '/exceptions'
      fullPath: '/rental-assets/exceptions'
      preLoaderRoute: typeof AppRentalAssetsExceptionsRouteImport
      parentRoute: typeof AppRentalAssetsRoute
    }
    '/_app/rental-assets/$assetId': {
      id: '/_app/rental-assets/$assetId'
      path: '/$assetId'
      fullPath: '/rental-assets/$assetId'
      preLoaderRoute: typeof AppRentalAssetsAssetIdRouteImport
      parentRoute: typeof AppRentalAssetsRoute
    }
    '/_app/quotes/scheduling': {
      id: '/_app/quotes/scheduling'
      path: '/quotes/scheduling'
      fullPath: '/quotes/scheduling'
      preLoaderRoute: typeof AppQuotesSchedulingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/new': {
      id: '/_app/quotes/new'
      path: '/quotes/new'
      fullPath: '/quotes/new'
      preLoaderRoute: typeof AppQuotesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/$quoteId': {
      id: '/_app/quotes/$quoteId'
      path: '/quotes/$quoteId'
      fullPath: '/quotes/$quoteId'
      preLoaderRoute: typeof AppQuotesQuoteIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs/$jobId': {
      id: '/_app/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof AppJobsJobIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/$invoiceId': {
      id: '/_app/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof AppInvoicesInvoiceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dispatch/report': {
      id: '/_app/dispatch/report'
      path: '/dispatch/report'
      fullPath: '/dispatch/report'
      preLoaderRoute: typeof AppDispatchReportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$customerId': {
      id: '/_app/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AppCustomersCustomerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workers/types/': {
      id: '/_app/workers/types/'
      path: '/types'
      fullPath: '/workers/types/'
      preLoaderRoute: typeof AppWorkersTypesIndexRouteImport
      parentRoute: typeof AppWorkersRoute
    }
    '/_app/rental-assets/types/': {
      id: '/_app/rental-assets/types/'
      path: '/types'
      fullPath: '/rental-assets/types/'
      preLoaderRoute: typeof AppRentalAssetsTypesIndexRouteImport
      parentRoute: typeof AppRentalAssetsRoute
    }
    '/_app/rental-assets/offerings/': {
      id: '/_app/rental-assets/offerings/'
      path: '/offerings'
      fullPath: '/rental-assets/offerings/'
      preLoaderRoute: typeof AppRentalAssetsOfferingsIndexRouteImport
      parentRoute: typeof AppRentalAssetsRoute
    }
    '/_app/rental-assets/companies/': {
      id: '/_app/rental-assets/companies/'
      path: '/companies'
      fullPath: '/rental-assets/companies/'
      preLoaderRoute: typeof AppRentalAssetsCompaniesIndexRouteImport
      parentRoute: typeof AppRentalAssetsRoute
    }
    '/_app/quotes/$quoteId/': {
      id: '/_app/quotes/$quoteId/'
      path: '/'
      fullPath: '/quotes/$quoteId/'
      preLoaderRoute: typeof AppQuotesQuoteIdIndexRouteImport
      parentRoute: typeof AppQuotesQuoteIdRoute
    }
    '/_app/projects/create/': {
      id: '/_app/projects/create/'
      path: '/projects/create'
      fullPath: '/projects/create/'
      preLoaderRoute: typeof AppProjectsCreateIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId/': {
      id: '/_app/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AppProjectsProjectIdIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/jobs/create/': {
      id: '/_app/jobs/create/'
      path: '/jobs/create'
      fullPath: '/jobs/create/'
      preLoaderRoute: typeof AppJobsCreateIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workers/types/$typeId': {
      id: '/_app/workers/types/$typeId'
      path: '/types/$typeId'
      fullPath: '/workers/types/$typeId'
      preLoaderRoute: typeof AppWorkersTypesTypeIdRouteImport
      parentRoute: typeof AppWorkersRoute
    }
    '/_app/rental-assets/types/$typeId': {
      id: '/_app/rental-assets/types/$typeId'
      path: '/types/$typeId'
      fullPath: '/rental-assets/types/$typeId'
      preLoaderRoute: typeof AppRentalAssetsTypesTypeIdRouteImport
      parentRoute: typeof AppRentalAssetsRoute
    }
    '/_app/rental-assets/stock/$typeId': {
      id: '/_app/rental-assets/stock/$typeId'
      path: '/stock/$typeId'
      fullPath: '/rental-assets/stock/$typeId'
      preLoaderRoute: typeof AppRentalAssetsStockTypeIdRouteImport
      parentRoute: typeof AppRentalAssetsRoute
    }
    '/_app/quotes/$quoteId/scheduling': {
      id: '/_app/quotes/$quoteId/scheduling'
      path: '/scheduling'
      fullPath: '/quotes/$quoteId/scheduling'
      preLoaderRoute: typeof AppQuotesQuoteIdSchedulingRouteImport
      parentRoute: typeof AppQuotesQuoteIdRoute
    }
    '/_app/quotes/$quoteId/requirements': {
      id: '/_app/quotes/$quoteId/requirements'
      path: '/requirements'
      fullPath: '/quotes/$quoteId/requirements'
      preLoaderRoute: typeof AppQuotesQuoteIdRequirementsRouteImport
      parentRoute: typeof AppQuotesQuoteIdRoute
    }
    '/_app/projects/create/$': {
      id: '/_app/projects/create/$'
      path: '/projects/create/$'
      fullPath: '/projects/create/$'
      preLoaderRoute: typeof AppProjectsCreateSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId/service-visits': {
      id: '/_app/projects/$projectId/service-visits'
      path: '/service-visits'
      fullPath: '/projects/$projectId/service-visits'
      preLoaderRoute: typeof AppProjectsProjectIdServiceVisitsRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/more-sites': {
      id: '/_app/projects/$projectId/more-sites'
      path: '/more-sites'
      fullPath: '/projects/$projectId/more-sites'
      preLoaderRoute: typeof AppProjectsProjectIdMoreSitesRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/jobs/create/$step': {
      id: '/_app/jobs/create/$step'
      path: '/jobs/create/$step'
      fullPath: '/jobs/create/$step'
      preLoaderRoute: typeof AppJobsCreateStepRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/$quoteId/create-project/': {
      id: '/_app/quotes/$quoteId/create-project/'
      path: '/create-project'
      fullPath: '/quotes/$quoteId/create-project/'
      preLoaderRoute: typeof AppQuotesQuoteIdCreateProjectIndexRouteImport
      parentRoute: typeof AppQuotesQuoteIdRoute
    }
    '/_app/quotes/$quoteId/create-project/$': {
      id: '/_app/quotes/$quoteId/create-project/$'
      path: '/create-project/$'
      fullPath: '/quotes/$quoteId/create-project/$'
      preLoaderRoute: typeof AppQuotesQuoteIdCreateProjectSplatRouteImport
      parentRoute: typeof AppQuotesQuoteIdRoute
    }
    '/_app/projects/$projectId/schedules/$scheduleId': {
      id: '/_app/projects/$projectId/schedules/$scheduleId'
      path: '/schedules/$scheduleId'
      fullPath: '/projects/$projectId/schedules/$scheduleId'
      preLoaderRoute: typeof AppProjectsProjectIdSchedulesScheduleIdRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/jobs/create': {
      id: '/_app/projects/$projectId/jobs/create'
      path: '/jobs/create'
      fullPath: '/projects/$projectId/jobs/create'
      preLoaderRoute: typeof AppProjectsProjectIdJobsCreateRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/jobs/add': {
      id: '/_app/projects/$projectId/jobs/add'
      path: '/jobs/add'
      fullPath: '/projects/$projectId/jobs/add'
      preLoaderRoute: typeof AppProjectsProjectIdJobsAddRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/jobs/create/done/$jobId': {
      id: '/_app/jobs/create/done/$jobId'
      path: '/jobs/create/done/$jobId'
      fullPath: '/jobs/create/done/$jobId'
      preLoaderRoute: typeof AppJobsCreateDoneJobIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId/jobs/create/$': {
      id: '/_app/projects/$projectId/jobs/create/$'
      path: '/$'
      fullPath: '/projects/$projectId/jobs/create/$'
      preLoaderRoute: typeof AppProjectsProjectIdJobsCreateSplatRouteImport
      parentRoute: typeof AppProjectsProjectIdJobsCreateRoute
    }
  }
}

interface AppRentalAssetsRouteChildren {
  AppRentalAssetsAssetIdRoute: typeof AppRentalAssetsAssetIdRoute
  AppRentalAssetsExceptionsRoute: typeof AppRentalAssetsExceptionsRoute
  AppRentalAssetsIndexRoute: typeof AppRentalAssetsIndexRoute
  AppRentalAssetsStockTypeIdRoute: typeof AppRentalAssetsStockTypeIdRoute
  AppRentalAssetsTypesTypeIdRoute: typeof AppRentalAssetsTypesTypeIdRoute
  AppRentalAssetsCompaniesIndexRoute: typeof AppRentalAssetsCompaniesIndexRoute
  AppRentalAssetsOfferingsIndexRoute: typeof AppRentalAssetsOfferingsIndexRoute
  AppRentalAssetsTypesIndexRoute: typeof AppRentalAssetsTypesIndexRoute
}

const AppRentalAssetsRouteChildren: AppRentalAssetsRouteChildren = {
  AppRentalAssetsAssetIdRoute: AppRentalAssetsAssetIdRoute,
  AppRentalAssetsExceptionsRoute: AppRentalAssetsExceptionsRoute,
  AppRentalAssetsIndexRoute: AppRentalAssetsIndexRoute,
  AppRentalAssetsStockTypeIdRoute: AppRentalAssetsStockTypeIdRoute,
  AppRentalAssetsTypesTypeIdRoute: AppRentalAssetsTypesTypeIdRoute,
  AppRentalAssetsCompaniesIndexRoute: AppRentalAssetsCompaniesIndexRoute,
  AppRentalAssetsOfferingsIndexRoute: AppRentalAssetsOfferingsIndexRoute,
  AppRentalAssetsTypesIndexRoute: AppRentalAssetsTypesIndexRoute,
}

const AppRentalAssetsRouteWithChildren = AppRentalAssetsRoute._addFileChildren(
  AppRentalAssetsRouteChildren,
)

interface AppWorkersRouteChildren {
  AppWorkersWorkerIdRoute: typeof AppWorkersWorkerIdRoute
  AppWorkersIndexRoute: typeof AppWorkersIndexRoute
  AppWorkersTypesTypeIdRoute: typeof AppWorkersTypesTypeIdRoute
  AppWorkersTypesIndexRoute: typeof AppWorkersTypesIndexRoute
}

const AppWorkersRouteChildren: AppWorkersRouteChildren = {
  AppWorkersWorkerIdRoute: AppWorkersWorkerIdRoute,
  AppWorkersIndexRoute: AppWorkersIndexRoute,
  AppWorkersTypesTypeIdRoute: AppWorkersTypesTypeIdRoute,
  AppWorkersTypesIndexRoute: AppWorkersTypesIndexRoute,
}

const AppWorkersRouteWithChildren = AppWorkersRoute._addFileChildren(
  AppWorkersRouteChildren,
)

interface AppProjectsProjectIdJobsCreateRouteChildren {
  AppProjectsProjectIdJobsCreateSplatRoute: typeof AppProjectsProjectIdJobsCreateSplatRoute
}

const AppProjectsProjectIdJobsCreateRouteChildren: AppProjectsProjectIdJobsCreateRouteChildren =
  {
    AppProjectsProjectIdJobsCreateSplatRoute:
      AppProjectsProjectIdJobsCreateSplatRoute,
  }

const AppProjectsProjectIdJobsCreateRouteWithChildren =
  AppProjectsProjectIdJobsCreateRoute._addFileChildren(
    AppProjectsProjectIdJobsCreateRouteChildren,
  )

interface AppProjectsProjectIdRouteChildren {
  AppProjectsProjectIdMoreSitesRoute: typeof AppProjectsProjectIdMoreSitesRoute
  AppProjectsProjectIdServiceVisitsRoute: typeof AppProjectsProjectIdServiceVisitsRoute
  AppProjectsProjectIdIndexRoute: typeof AppProjectsProjectIdIndexRoute
  AppProjectsProjectIdJobsAddRoute: typeof AppProjectsProjectIdJobsAddRoute
  AppProjectsProjectIdJobsCreateRoute: typeof AppProjectsProjectIdJobsCreateRouteWithChildren
  AppProjectsProjectIdSchedulesScheduleIdRoute: typeof AppProjectsProjectIdSchedulesScheduleIdRoute
}

const AppProjectsProjectIdRouteChildren: AppProjectsProjectIdRouteChildren = {
  AppProjectsProjectIdMoreSitesRoute: AppProjectsProjectIdMoreSitesRoute,
  AppProjectsProjectIdServiceVisitsRoute:
    AppProjectsProjectIdServiceVisitsRoute,
  AppProjectsProjectIdIndexRoute: AppProjectsProjectIdIndexRoute,
  AppProjectsProjectIdJobsAddRoute: AppProjectsProjectIdJobsAddRoute,
  AppProjectsProjectIdJobsCreateRoute:
    AppProjectsProjectIdJobsCreateRouteWithChildren,
  AppProjectsProjectIdSchedulesScheduleIdRoute:
    AppProjectsProjectIdSchedulesScheduleIdRoute,
}

const AppProjectsProjectIdRouteWithChildren =
  AppProjectsProjectIdRoute._addFileChildren(AppProjectsProjectIdRouteChildren)

interface AppQuotesQuoteIdRouteChildren {
  AppQuotesQuoteIdRequirementsRoute: typeof AppQuotesQuoteIdRequirementsRoute
  AppQuotesQuoteIdSchedulingRoute: typeof AppQuotesQuoteIdSchedulingRoute
  AppQuotesQuoteIdIndexRoute: typeof AppQuotesQuoteIdIndexRoute
  AppQuotesQuoteIdCreateProjectSplatRoute: typeof AppQuotesQuoteIdCreateProjectSplatRoute
  AppQuotesQuoteIdCreateProjectIndexRoute: typeof AppQuotesQuoteIdCreateProjectIndexRoute
}

const AppQuotesQuoteIdRouteChildren: AppQuotesQuoteIdRouteChildren = {
  AppQuotesQuoteIdRequirementsRoute: AppQuotesQuoteIdRequirementsRoute,
  AppQuotesQuoteIdSchedulingRoute: AppQuotesQuoteIdSchedulingRoute,
  AppQuotesQuoteIdIndexRoute: AppQuotesQuoteIdIndexRoute,
  AppQuotesQuoteIdCreateProjectSplatRoute:
    AppQuotesQuoteIdCreateProjectSplatRoute,
  AppQuotesQuoteIdCreateProjectIndexRoute:
    AppQuotesQuoteIdCreateProjectIndexRoute,
}

const AppQuotesQuoteIdRouteWithChildren =
  AppQuotesQuoteIdRoute._addFileChildren(AppQuotesQuoteIdRouteChildren)

interface AppRouteChildren {
  AppActiveRentalsRoute: typeof AppActiveRentalsRoute
  AppOrdersRoute: typeof AppOrdersRoute
  AppRentalAssetsRoute: typeof AppRentalAssetsRouteWithChildren
  AppWorkersRoute: typeof AppWorkersRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppCustomersCustomerIdRoute: typeof AppCustomersCustomerIdRoute
  AppDispatchReportRoute: typeof AppDispatchReportRoute
  AppInvoicesInvoiceIdRoute: typeof AppInvoicesInvoiceIdRoute
  AppJobsJobIdRoute: typeof AppJobsJobIdRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRouteWithChildren
  AppQuotesQuoteIdRoute: typeof AppQuotesQuoteIdRouteWithChildren
  AppQuotesNewRoute: typeof AppQuotesNewRoute
  AppQuotesSchedulingRoute: typeof AppQuotesSchedulingRoute
  AppReportsRentalRoute: typeof AppReportsRentalRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppDispatchIndexRoute: typeof AppDispatchIndexRoute
  AppInvoicesIndexRoute: typeof AppInvoicesIndexRoute
  AppJobsIndexRoute: typeof AppJobsIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppQuotesIndexRoute: typeof AppQuotesIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
  AppJobsCreateStepRoute: typeof AppJobsCreateStepRoute
  AppProjectsCreateSplatRoute: typeof AppProjectsCreateSplatRoute
  AppJobsCreateIndexRoute: typeof AppJobsCreateIndexRoute
  AppProjectsCreateIndexRoute: typeof AppProjectsCreateIndexRoute
  AppJobsCreateDoneJobIdRoute: typeof AppJobsCreateDoneJobIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActiveRentalsRoute: AppActiveRentalsRoute,
  AppOrdersRoute: AppOrdersRoute,
  AppRentalAssetsRoute: AppRentalAssetsRouteWithChildren,
  AppWorkersRoute: AppWorkersRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppCustomersCustomerIdRoute: AppCustomersCustomerIdRoute,
  AppDispatchReportRoute: AppDispatchReportRoute,
  AppInvoicesInvoiceIdRoute: AppInvoicesInvoiceIdRoute,
  AppJobsJobIdRoute: AppJobsJobIdRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRouteWithChildren,
  AppQuotesQuoteIdRoute: AppQuotesQuoteIdRouteWithChildren,
  AppQuotesNewRoute: AppQuotesNewRoute,
  AppQuotesSchedulingRoute: AppQuotesSchedulingRoute,
  AppReportsRentalRoute: AppReportsRentalRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppDispatchIndexRoute: AppDispatchIndexRoute,
  AppInvoicesIndexRoute: AppInvoicesIndexRoute,
  AppJobsIndexRoute: AppJobsIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppQuotesIndexRoute: AppQuotesIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
  AppJobsCreateStepRoute: AppJobsCreateStepRoute,
  AppProjectsCreateSplatRoute: AppProjectsCreateSplatRoute,
  AppJobsCreateIndexRoute: AppJobsCreateIndexRoute,
  AppProjectsCreateIndexRoute: AppProjectsCreateIndexRoute,
  AppJobsCreateDoneJobIdRoute: AppJobsCreateDoneJobIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  DispatchTimelineRoute: DispatchTimelineRoute,
  LoginRoute: LoginRoute,
  VerifyRoute: VerifyRoute,
  DriverJobsJobIdRoute: DriverJobsJobIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
